import React, { useContext, useState, useEffect } from "react";
import Email from "@material-ui/icons/Email";
import Lock from "@material-ui/icons/Lock";
import { useHistory } from "react-router-dom";
import "./style.scss";
import { AuthContext } from "../../context/authContext/AuthContext";
import { loginUser } from "../../context/authContext/apiCalls";
import { Snackbar, Alert, IconButton, Tooltip } from "@mui/material";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

const Login = ({ setLoginUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { isFetching, dispatch, error, user } = useContext(AuthContext);

  const history = useHistory();

  const [toast, setToast] = useState({ open: false, msg: "", severity: "info" });
  const openToast = (msg, severity = "info") => setToast({ open: true, msg, severity });
  const closeToast = () => setToast((t) => ({ ...t, open: false }));

  const handleLogin = () => {
    if (!(email && password)) {
      openToast("Please fill all fields", "error");
      return;
    }
    loginUser({ email, password }, dispatch);
  };

  useEffect(() => {
    if (user && !isFetching) {
      openToast("Login Successful", "success");
    }
  }, [user, isFetching]);

  useEffect(() => {
    if (error && !isFetching) {
      const status = error?.response?.status;
      if (status === 401) openToast("Incorrect Email/Password", "error");
      else openToast("Login failed. Please try again.", "error");
    }
  }, [error, isFetching]);

  return (
    <div className="login">
      <div className="card">
        <div className="card2">
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <p id="heading">Login</p>

            <div className="field">
              <Email className="input-icon" />
              <input
                type="text"
                className="input-field"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                autoComplete="off"
              />
            </div>

            <div className="field">
              <Lock className="input-icon" />
              <input
                type="password"
                className="input-field"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
              />
            </div>

            <div className="btn">
              <button
                type="button"
                className="button1"
                onClick={handleLogin}
                disabled={isFetching}
              >
                Login
              </button>
              <button
                type="button"
                className="button2"
                onClick={() => history.push("/register")}
              >
                Sign Up
              </button>
            </div>
            <div className="social-links">
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/karannkx"
                  target="_blank"
                  rel="noopener"
                  aria-label="GitHub profile"
                  className="social-btn uniform"
                >
                  <FaGithub size={22} />
                </IconButton>
              </Tooltip>
              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/karannkx"
                  target="_blank"
                  rel="noopener"
                  aria-label="LinkedIn profile"
                  className="social-btn uniform"
                >
                  <FaLinkedin size={22} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Instagram">
                <IconButton
                  component="a"
                  href="https://instagram.com/karannkx"
                  target="_blank"
                  rel="noopener"
                  aria-label="Instagram profile"
                  className="social-btn uniform"
                >
                  <FaInstagram size={22} />
                </IconButton>
              </Tooltip>
            </div>
          </form>
        </div>
      </div>

      <Snackbar
        open={toast.open}
        autoHideDuration={2500}
        onClose={closeToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={closeToast} severity={toast.severity} variant="filled" sx={{ bgcolor: toast.severity === 'success' ? 'primary.main' : undefined }}>
          {toast.msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Login;
